import {type MinimumAnalyticsProviderConfig, registerProvider} from "@plaudit/analytics-integrations-api";

declare global {
	interface Window extends Partial<Record<'clarityMS'|'facebookPixel'|'linkedInInsightTag'|'zoomInfo'|'microsoftUET', MinimumAnalyticsProviderConfig>> {}
}

const nonce = document.currentScript?.nonce;

if (window.clarityMS) {
	registerProvider({
		name: 'Clarity MS',
		categories: window.clarityMS.categories,
		activate({injectTrackerScript}) {
			injectTrackerScript(`https://www.clarity.ms/tag/${window.clarityMS!.projectId}`, {pos: 'first', nonce});
		}
	});
}

if (window.facebookPixel) {
	registerProvider({
		name: 'Facebook Pixel',
		categories: window.facebookPixel.categories,
		activate({injectTrackerScript}) {
			injectTrackerScript("https://connect.facebook.net/en_US/fbevents.js", {pos: 'first', nonce});
		}
	});
}

if (window.linkedInInsightTag) {
	registerProvider({
		name: 'LinkedIn Insight Tag',
		categories: window.linkedInInsightTag.categories,
		activate({injectTrackerScript}) {
			((window as any)._linkedin_data_partner_ids||((window as any)._linkedin_data_partner_ids=[])).push(window.linkedInInsightTag!.projectId);
			injectTrackerScript("https://snap.licdn.com/li.lms-analytics/insight.min.js", {pos: 'first', nonce});
		}
	});
}

if (window.zoomInfo) {
	registerProvider({
		name: 'ZoomInfo',
		categories: window.zoomInfo.categories,
		activate({injectTrackerScript}) {
			(window as any).ZIProjectKey = window.zoomInfo!.projectId;
			injectTrackerScript("https://js.zi-scripts.com/zi-tag.js", {pos: 'last', nonce});
		}
	});
}

declare class UET {
	constructor(o: any);
}

if (window.microsoftUET) {
	registerProvider({
		name: 'MicrosoftUET',
		categories: window.microsoftUET.categories,
		activate({injectTrackerScript}) {
			const script = injectTrackerScript("//bat.bing.com/bat.js", {pos: 'first', nonce});
			script.onload = () => {
				(window as any).uetq = (window as any).uetq||[];
				const o = {ti: window.microsoftUET!.projectId, enableAutoSpaTracking: true, q: (window as any).uetq};
				(window as any).uetq = new UET(o);
				(window as any).uetq.push("pageLoad");
			};
		}
	});
}

import "./providers/loader";
